import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from 'src/app/services';

@Component({
  selector: 'app-tab-superior',
  templateUrl: './tab-superior.component.html',
  styleUrls: ['./tab-superior.component.scss']
})
export class TabSuperiorComponent implements OnInit {
  @Output() toggleSidenavEmit = new EventEmitter();
  nomeUsuario = '';

  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.nomeUsuario = this.authenticationService.obterToken().nome;
  }

  toggleSidenav() {
    this.toggleSidenavEmit.emit();
  }
}
